module.exports = __webpack_public_path__ + "img/pythonr.8c1c6696.png";